import { render, staticRenderFns } from "./CoreTasks.vue?vue&type=template&id=10b8dd09&scoped=true&"
import script from "./CoreTasks.vue?vue&type=script&lang=js&"
export * from "./CoreTasks.vue?vue&type=script&lang=js&"
import style0 from "./CoreTasks.vue?vue&type=style&index=0&id=10b8dd09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8dd09",
  null
  
)

export default component.exports